import React from "react";
import BookNavbar from "./BookNavbar";
import BookHero from "./BookHero";
import BookStation from "./BookStation";

const BookaSlot = () => {
  return (
    <div>
        <BookNavbar />
        <BookHero />
        <BookStation />
    </div>
  )
}

export default BookaSlot
